(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Advice', Advice);

    Advice.$inject = ['$resource', 'DateUtils'];

    function Advice ($resource, DateUtils) {
        var resourceUrl =  'api/advices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate){
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate !== null) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate !== null) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.issueDate !== null) {
                        copy.issueDate = DateUtils.convertLocalDateToServer(copy.issueDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate){
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate !== null) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate !== null) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.issueDate !== null) {
                        copy.issueDate = DateUtils.convertLocalDateToServer(copy.issueDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate !== null) {
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();
